import TextFieldController from "confinus_ui/forms/text_field_controller";

export default class NumberFieldController extends TextFieldController {}
